import { render, staticRenderFns } from "./taxiList.vue?vue&type=template&id=24ec2059&v-else=true&"
import script from "./taxiList.vue?vue&type=script&lang=ts&"
export * from "./taxiList.vue?vue&type=script&lang=ts&"
import style0 from "./taxiList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports